/**
 * Agent Pages -- Suggestions
 *
 * Wraps the SuggestionsTab scoped to the current chatbot.
 */

import React from 'react'
import { useAgentContext } from '../../../components/layout/AgentContextLayout'
import { SuggestionsTab } from '../AgentHubTabs/SuggestionsTab'

export const SuggestionsPage: React.FC = () => {
  const { chatbot } = useAgentContext()

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold tracking-tight text-foreground">Suggestions</h1>
      <SuggestionsTab chatbot={chatbot} />
    </div>
  )
}
